import { ILinkConfig } from '@/finsight/ui/common/components/header/Header/Links/linksConfig';
import URL from '@/finsight/Router/urlConstants';

const linksConfig: ILinkConfig[] = [
  {
    url: URL.ABOUT,
    dataTest: 'aboutUs',
    label: 'About Us',
  },
  {
    url: URL.SOLUTIONS,
    dataTest: 'solutions',
    label: 'Solutions',
  },
  {
    url: URL.CAREERS,
    dataTest: 'careers',
    label: 'Careers',
  },
  {
    url: URL.CONTACT,
    dataTest: 'contact',
    label: 'Contact',
  },
];

export default linksConfig;
